import React from 'react';
import './PetAnimations.css';

export default function ParrotSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#4CAF50';
  const wingColor = color || '#2196F3';
  const chestColor = '#FFD54F';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail feathers */}
      <path d="M55 92L48 110" stroke="#E53935" strokeWidth="4" strokeLinecap="round" />
      <path d="M60 92L60 112" stroke={bodyColor} strokeWidth="4" strokeLinecap="round" />
      <path d="M65 92L72 110" stroke={wingColor} strokeWidth="4" strokeLinecap="round" />
      {/* Body */}
      <ellipse cx="60" cy="72" rx="22" ry="24" fill={bodyColor} />
      {/* Chest */}
      <ellipse cx="60" cy="76" rx="14" ry="16" fill={chestColor} />
      {/* Left wing */}
      <path
        d="M38 62C30 66 24 74 26 80C28 84 34 78 38 72"
        fill={wingColor}
        stroke="none"
      />
      {/* Right wing */}
      <path
        d="M82 62C90 66 96 74 94 80C92 84 86 78 82 72"
        fill={wingColor}
        stroke="none"
      />
      {/* Feet */}
      <path d="M50 94L46 100L44 98" stroke="#FF8F00" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M50 94L50 100L48 98" stroke="#FF8F00" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M70 94L74 100L76 98" stroke="#FF8F00" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M70 94L70 100L72 98" stroke="#FF8F00" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      {/* Head */}
      <circle cx="60" cy="38" r="18" fill={bodyColor} />
      {/* Head crest */}
      <path d="M54 22C56 14 64 14 66 22C66 22 62 18 60 20C58 18 54 22 54 22Z" fill="#E53935" />
      {/* Eye rings */}
      <circle cx="51" cy="36" r="6" fill="white" />
      <circle cx="69" cy="36" r="6" fill="white" />
      {/* Eyes */}
      <circle cx="52" cy="36" r="3.5" fill="#2C2419" />
      <circle cx="70" cy="36" r="3.5" fill="#2C2419" />
      <circle cx="53" cy="34.5" r="1.2" fill="white" />
      <circle cx="71" cy="34.5" r="1.2" fill="white" />
      {/* Beak */}
      <path d="M56 42C56 42 60 48 60 48L64 42C64 42 62 40 60 40C58 40 56 42 56 42Z" fill="#FF8F00" />
      <path d="M57 43L60 46L63 43" stroke="#E65100" strokeWidth="0.8" fill="none" />
    </svg>
  );
}
